import classes from './TabHeader.module.css'

const TabHeader = ({children}) => {
    return <div className={`${classes.tab_header} tab-header-for-background`}>{children}</div>
}

export default TabHeader